import { useContextState } from '../../../../../../hooks/theme'

function useStyles() {
  const { colors } = useContextState()
  return {
    listContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    countBadge: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      backgroundColor: 'primary.100',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      fontWeight: '600',
    },
    card: {
      cursor: 'pointer',
      transition: '.2s ease',
      '&:hover': {
        boxShadow: '0px 2px 0px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0px 4px 0px rgba(0,0,0,0.12)',
      },
    },
    noData: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      padding: '40px 20px',
      textAlign: 'center',
      color: colors.color13,
      '& .MuiSvgIcon-root': {
        fontSize: '48px',
        color: colors.color13,
      },
    },
    detailGrid: {
      alignItems: 'stretch',
    },
    leftColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    },
    detailContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      height: '100%',
      minHeight: '300px',
    },
    detailTitle: {
      fontSize: '16px',
      fontWeight: '700',
      color: colors.color13,
    },
    downloadButton: {
      width: 'fit-content',
      alignSelf: 'flex-start',
    },
    commentBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
    },
    commentTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    commentText: {
      fontSize: '16px',
      color: colors.color22,
      wordBreak: 'break-word',
    },
    actionsWrapper: {
      marginTop: 'auto',
      width: '100%',
    },
    actionsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 2,
    },
  }
}

export { useStyles }
